/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuildFileDto } from '../../models/build-file-dto';

export interface BuildFileControllerFindById$Params {
  id: string;
}

export function buildFileControllerFindById(http: HttpClient, rootUrl: string, params: BuildFileControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
  const rb = new RequestBuilder(rootUrl, buildFileControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BuildFileDto>;
    })
  );
}

buildFileControllerFindById.PATH = '/api/build-file/{id}';
